'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";

import {ReportsListCtrl} from "./reportslistctrl.js";
EwSiteApp.controller('ReportsListCtrl', ["$scope", "$filter", "$http", "$mdDialog", "$httpParamSerializerJQLike", "jsDataService", "notify", ReportsListCtrl]);

import {ItemCreateCtrl} from "./itemcreatectrl.js";
EwSiteApp.controller('ItemCreateCtrl', ["$scope", "$filter", "$http", "$mdDialog", "jsDataService", "notify", ItemCreateCtrl]);

import {ItemEditCtrl} from "./itemeditctrl.js";
EwSiteApp.controller('ItemEditCtrl', ["$scope", "$filter", "$http", "$mdDialog", "jsDataService", "notify", ItemEditCtrl]);

import {ItemPreviewCtrl} from "./itempreviewctrl.js";
EwSiteApp.controller('ItemPreviewCtrl', ["$scope", "$filter", "$http", "$mdDialog", "jsDataService", "notify", ItemPreviewCtrl]);


import {ItemMessagesCtrl} from "./itemmessagesctrl.js";
EwSiteApp.controller('ItemMessagesCtrl', ["$scope", "$filter", "$http", "$mdDialog", "jsDataService", "notify", ItemMessagesCtrl]);


import {StatisticsListCtrl} from "./statisticslistctrl.js";
EwSiteApp.controller('StatisticsListCtrl', ["$scope", "$filter", "$http", "$mdDialog", "$httpParamSerializerJQLike", "jsDataService", "notify", StatisticsListCtrl]);

import {SentMessagesListCtrl} from "./sentmessageslistctrl.js";
EwSiteApp.controller('SentMessagesListCtrl', ["$scope", "$filter", "$http", "$mdDialog", "$httpParamSerializerJQLike", "jsDataService", "notify", SentMessagesListCtrl]);

import {ChangelogCtrl} from "./changelogctrl.js";
EwSiteApp.controller('ChangelogCtrl', ["$scope", "$filter", "$http", "$mdDialog", "jsDataService", "notify", ChangelogCtrl]);

import {ProfileEditCtrl} from "./profileeditctrl.js";
EwSiteApp.controller('ProfileEditCtrl', ["$scope", "$filter", "$http", "$mdDialog", "jsDataService", "notify", ProfileEditCtrl]);